import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import type { OnboardingDetails } from '../../types';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class OnboardingService {
  private readonly api = inject(ApiService);

  complete(details: OnboardingDetails): Observable<void> {
    return this.api.post<void>('onboarding/complete', details, { resource: 'auth-api' });
  }
}
